import React, { createContext, useContext, useState, useEffect } from 'react';

const translations = {
  it: {
    // Navigation
    nav: {
      features: 'Funzionalità',
      pricing: 'Prezzi',
      about: 'Chi Siamo',
      contact: 'Contatti',
      login: 'Accedi',
      register: 'Registrati',
      dashboard: 'Dashboard',
      logout: 'Esci'
    },
    // Hero
    hero: {
      overline: 'PIATTAFORMA DI RISK MANAGEMENT',
      title: 'L\'Intelligenza delle',
      titleHighlight: 'Informazioni',
      subtitle: 'Una sola piattaforma per gestire i rischi della tua azienda: finanziari, di compliance, di sicurezza e cyber. Business Information, antiriciclaggio, whistleblowing, travel security e servizi cyber in un unico accesso.',
      cta: 'Abbonati ora',
      ctaSecondary: 'Scopri di più',
      trial: 'Prova gratuita 3 giorni'
    },
    // Features
    features: {
      overline: 'FUNZIONALITÀ',
      title: 'Quattro aree di rischio, un\'unica piattaforma',
      subtitle: 'Financial Risk · HR & Compliance · Sicurezza · Cyber Security & Data Leakage',
      items: [
        {
          title: 'Financial Risk',
          description: 'Report Business Information con rating e fido, grafo delle relazioni, monitoraggio, immobili, OSINT, rintraccio patrimoniale e controlli AML.'
        },
        {
          title: 'HR & Compliance',
          description: 'Check dei candidati pre-assunzione e canale whistleblowing conforme al D.Lgs. 24/2023, con kit documenti di legge.'
        },
        {
          title: 'Sicurezza',
          description: 'Travel Security: indice di rischio BOND da 8 fonti istituzionali, avvisi email e SMS per chi viaggia.'
        },
        {
          title: 'Cyber Security & Data Leakage',
          description: 'Vulnerability assessment e penetration test, Cyber risk investigation per la ricerca di dati esposti, piattaforma di cyber awareness con simulazioni di attacco, verifiche di sicurezza.'
        },
        {
          title: 'Reputational check e AML',
          description: 'Verifiche antiriciclaggio, PEP, PIL, Adverse Media, Panama Papers, Sentenze di Cassazione e molto altro.'
        },
        {
          title: 'Plafond e team',
          description: 'Credito prepagato, sotto-utenti con permessi e limiti di spesa, estratti mensili per servizio.'
        }
      ]
    },
    // Pricing
    pricing: {
      overline: 'PREZZI',
      title: 'Scegli il piano perfetto per te',
      subtitle: 'Piani flessibili per ogni esigenza, dal professionista alla grande azienda',
      monthly: '/mese',
      popular: 'PIÙ POPOLARE',
      cta: 'Abbonati ora',
      ctaTrial: 'Prova gratis'
    },
    // Contact (kept for compatibility but section removed)
    contact: {
      overline: 'CONTATTI',
      title: 'Contattaci',
      subtitle: 'Siamo qui per aiutarti.',
      form: {
        name: 'Nome Completo',
        email: 'Email',
        company: 'Azienda (opzionale)',
        phone: 'Telefono (opzionale)',
        message: 'Messaggio',
        send: 'INVIA MESSAGGIO',
        success: 'Messaggio inviato con successo!',
        error: 'Errore nell\'invio. Riprova.'
      }
    },
    // Auth
    auth: {
      login: 'Accedi',
      register: 'Registrati',
      email: 'Email',
      password: 'Password',
      name: 'Nome Completo',
      company: 'Azienda (opzionale)',
      loginBtn: 'ACCEDI',
      registerBtn: 'REGISTRATI',
      noAccount: 'Non hai un account?',
      hasAccount: 'Hai già un account?',
      forgotPassword: 'Password dimenticata?'
    },
    // Payment
    payment: {
      title: 'Completa il pagamento',
      processing: 'Elaborazione pagamento...',
      success: 'Pagamento completato!',
      successMessage: 'Il tuo account OSINT è stato attivato.',
      credentials: 'Le tue credenziali temporanee:',
      username: 'Username',
      tempPassword: 'Password temporanea',
      goToDashboard: 'VAI ALLA DASHBOARD',
      error: 'Errore nel pagamento',
      selectMethod: 'Seleziona metodo di pagamento',
      stripe: 'Carta di credito',
      paypal: 'PayPal'
    },
    // Footer
    footer: {
      description: 'Piattaforma OSINT leader per Business Intelligence e analisi delle fonti aperte.',
      quickLinks: 'Link Rapidi',
      legal: 'Legale',
      privacy: 'Privacy Policy',
      terms: 'Termini di Servizio',
      cookies: 'Cookie Policy',
      rights: 'Tutti i diritti riservati.'
    },
    // Common
    common: {
      loading: 'Caricamento...',
      error: 'Si è verificato un errore',
      retry: 'Riprova',
      cancel: 'Annulla',
      confirm: 'Conferma',
      save: 'Salva',
      close: 'Chiudi'
    }
  },
  en: {
    // Navigation
    nav: {
      features: 'Features',
      pricing: 'Pricing',
      about: 'About Us',
      contact: 'Contact',
      login: 'Login',
      register: 'Sign Up',
      dashboard: 'Dashboard',
      logout: 'Logout'
    },
    // Hero
    hero: {
      overline: 'LEADING OSINT PLATFORM IN ITALY',
      title: 'The Intelligence of',
      titleHighlight: 'Information',
      subtitle: 'A simple and powerful software for all your Business Intelligence operations. Analyze companies, discover connections, monitor risks.',
      cta: 'Subscribe now',
      ctaSecondary: 'Learn more',
      trial: '3-day free trial'
    },
    // Features
    features: {
      overline: 'FEATURES',
      title: 'The best of OSINT in one platform',
      subtitle: 'Advanced Open Source Intelligence tools for professionals and businesses',
      items: [
        {
          title: 'Interactive Graph',
          description: 'Easily visualize nodes and relationships between companies and people. Expand connections infinitely.'
        },
        {
          title: 'Business Information',
          description: 'Access business registry, cadastral and financial information integrated in one platform.'
        },
        {
          title: 'AML/KYC Checks',
          description: 'Discover beneficial owners and perform checks on major Anti-Money Laundering databases.'
        },
        {
          title: 'Lead Generation',
          description: 'Select companies by economic parameters and download results for your sales activities.'
        },
        {
          title: 'Advanced Reports',
          description: 'Monitored Business Information reports with Rating, Commercial Credit and balance sheet analysis.'
        },
        {
          title: 'Continuous Monitoring',
          description: 'Receive automatic alerts on corporate changes, financial statements and news about monitored subjects.'
        }
      ]
    },
    // Pricing
    pricing: {
      overline: 'PRICING',
      title: 'Choose the perfect plan for you',
      subtitle: 'Flexible plans for every need, from professional to enterprise',
      monthly: '/month',
      popular: 'MOST POPULAR',
      cta: 'Subscribe now',
      ctaTrial: 'Try free'
    },
    // Contact
    contact: {
      overline: 'CONTACT',
      title: 'Let\'s talk about your project',
      subtitle: 'We\'re here to help. Contact us for information or custom requests.',
      form: {
        name: 'Full Name',
        email: 'Email',
        company: 'Company (optional)',
        phone: 'Phone (optional)',
        message: 'Message',
        send: 'SEND MESSAGE',
        success: 'Message sent successfully!',
        error: 'Error sending. Please try again.'
      }
    },
    // Auth
    auth: {
      login: 'Login',
      register: 'Sign Up',
      email: 'Email',
      password: 'Password',
      name: 'Full Name',
      company: 'Company (optional)',
      loginBtn: 'LOGIN',
      registerBtn: 'SIGN UP',
      noAccount: 'Don\'t have an account?',
      hasAccount: 'Already have an account?',
      forgotPassword: 'Forgot password?'
    },
    // Payment
    payment: {
      title: 'Complete Payment',
      processing: 'Processing payment...',
      success: 'Payment completed!',
      successMessage: 'Your OSINT account has been activated.',
      credentials: 'Your temporary credentials:',
      username: 'Username',
      tempPassword: 'Temporary password',
      goToDashboard: 'GO TO DASHBOARD',
      error: 'Payment error',
      selectMethod: 'Select payment method',
      stripe: 'Credit card',
      paypal: 'PayPal'
    },
    // Footer
    footer: {
      description: 'Leading OSINT platform for Business Intelligence and open source analysis.',
      quickLinks: 'Quick Links',
      legal: 'Legal',
      privacy: 'Privacy Policy',
      terms: 'Terms of Service',
      cookies: 'Cookie Policy',
      rights: 'All rights reserved.'
    },
    // Common
    common: {
      loading: 'Loading...',
      error: 'An error occurred',
      retry: 'Retry',
      cancel: 'Cancel',
      confirm: 'Confirm',
      save: 'Save',
      close: 'Close'
    }
  }
};

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('smartinfo_language');
    return saved || 'it';
  });

  useEffect(() => {
    localStorage.setItem('smartinfo_language', language);
  }, [language]);

  const t = (key) => {
    const keys = key.split('.');
    let value = translations[language];
    for (const k of keys) {
      if (value && value[k] !== undefined) {
        value = value[k];
      } else {
        return key;
      }
    }
    return value;
  };

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'it' ? 'en' : 'it');
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t, toggleLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}
